import { useQueryIntegrationsList } from '../../models/useQueryIntegrationsList'

export const useGetIntegrationsListPresenter = ({
  enabled = true,
}: {
  enabled?: boolean
} = {}) => {
  const { integrations, isLoading, isError } = useQueryIntegrationsList({
    enabled,
  })

  return {
    data: {
      integrations,
    },
    states: {
      isLoading,
      isError,
    },
  }
}
